import { useRoom, useTeller } from '@raysee/hooks';
import { Payment, Room, Teller } from '@raysee/schema';
import { businessDaysLaterFrom } from '@raysee/utility';
import dayjs from 'dayjs';
import { VFC } from 'react';
import { Link } from '../../Link';
import { Bubble, Props } from './Bubble';

export const FinishedBubble = (props: Props) => {
  const [room] = useRoom(props.room.id);
  const [teller] = useTeller(room?.tellerId);

  if (!room || !teller) return <Bubble {...props}></Bubble>;

  return (
    <Bubble {...props}>
      <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
        {props.role === 'user' ? (
          <UserBubble room={room} teller={teller} payment={room.payment} isPhone={props.isPhone} />
        ) : (
          <p className="text-white">以上で鑑定が終了しました。</p>
        )}
      </div>
    </Bubble>
  );
};

interface UserBubbleProps {
  room: Room;
  teller: Teller;
  payment: Payment;
  isPhone?: boolean;
}

const UserBubble: VFC<UserBubbleProps> = ({ room, teller, payment, isPhone }) => (
  <>
    <p className="text-white">
      【鑑定が終了しました】
      <br />
      ありがとうございました！
      <br />
      {`${teller.name}`}先生の鑑定はいかがだったでしょうか？
      <br />
      <br />
      ただいま鑑定をレビューしてくれた方全員に、次回以降の鑑定で使える特別クーポンをプレゼントしております。
    </p>
    <Link
      href={`${isPhone ? '/phone' : ''}/rooms/${room.tellerId}/reviews/${room.id}`}
      legacyBehavior
    >
      <div>
        <p className="inline text-white hover:cursor-pointer">▶︎ </p>
        <p className="inline text-white underline hover:cursor-pointer">鑑定をレビューする</p>
      </div>
    </Link>
    {payment === Payment.Bank && (
      <>
        <br />
        <br />
        <p className="text-white">
          【お支払いについて】
          <br />
          今回の鑑定料金のお支払い期限は
          <br />
          <span className="font-bold">{`${
            !!room.endTime && dayjs(businessDaysLaterFrom(room.endTime, 5)).format('YYYY/MM/DD')
          }`}</span>
          です。
          <br />
          お支払いの金額や振込先情報などは
          <Link
            href={`${isPhone ? '/phone' : ''}/rooms/${room.tellerId}/reviews/${room.id}`}
            legacyBehavior
          >
            <p className="inline text-white hover:cursor-pointer">
              &nbsp;<span className="font-bold underline">▶︎こちら</span>&nbsp;
            </p>
          </Link>
          からご確認ください。
        </p>
      </>
    )}
  </>
);
